import { useContext } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { addMapMode, removeMapMode } from 'client/store/mapSlice/mapSlice';
import { MapContext } from 'os-elements';
import Button from 'client/components/GDS/Button/Button';
import Icon from '@mdi/react';
import { mdiCheck } from '@mdi/js';
import { drawStates, mapModes } from 'client/utils/constants/appStates';
import { VALID_MODES } from './FinishButton.mode';
import mapModeIsValid from '../validateModes';

const { DEFAULT, DRAWING, MODIFYING } = mapModes;
const { INVALID, EXCEEDS_EXTENT, VALID } = drawStates;

const FinishButton = () => {
    const intl = useIntl();
    const { map } = useContext(MapContext);
    const dispatch = useDispatch();
    const mapMode = useSelector(state => state.map?.mode || []);
    const drawStatus = useSelector(state => state.draw?.status || []);

    const handleFinish = () => {
        const drawSource = map.getLayerById('draw').getSource();
        const aoiSource = map.getLayerById('aoi').getSource();
        aoiSource.clear();
        const features = drawSource.getFeatures();
        if (features && features.length > 0) {
            const feature = features[0].clone();
            aoiSource.addFeature(feature);
        }
        drawSource.clear();
        dispatch(removeMapMode(DRAWING));
        dispatch(removeMapMode(MODIFYING));
        dispatch(addMapMode(DEFAULT));
    };

    return mapModeIsValid(mapMode, VALID_MODES)
        ? <Button
            data-testid="mapToolBar.draw.finish"
            variant="success"
            onClick={handleFinish}
            disabled={(drawStatus.length > 0 && !drawStatus.includes(VALID)) || drawStatus.includes(INVALID) || drawStatus.includes(EXCEEDS_EXTENT)}
        >
            <Icon path={mdiCheck} size={0.7}/>
            { intl.formatMessage({ id: 'mapToolbar.finishButton.text' }) }
        </Button>
        : null;
};

export default FinishButton;
